/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="订单号">
        <el-input
          size="small"
          v-model="formInline.OrderID"
          placeholder="输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input
          size="small"
          v-model="formInline.CommodityName"
          placeholder="输入商品名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="来源渠道">
        <el-input
          size="small"
          v-model="formInline.Source"
          placeholder="输入来源渠道"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          size="small"
          v-model="formInline.OrderStateID"
          placeholder="请选择"
        >
          <el-option
            v-for="type in OrderStates"
            :label="type.key"
            :value="type.value"
            value-key="value"
            :key="type.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间">
        <el-date-picker
          size="mini"
          v-model="formInline.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="请选择日期"
          end-placeholder="请选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="eltable text-center lineHeight1">
      <div v-if="listData.length < 1">暂无相关数据</div>
      <div
        class="item"
        v-for="(item, index) in listData"
        :class="index < listData.length - 1 ? 'borderBottom' : ''"
        :key="index"
      >
        <div class="title flex between backgroundGray">
          <div>
            <span class="text-gray marginRight">{{ item.CREATETIME }}</span>
            <span class="text-gray">订单号:</span>{{ item.OrderID }}
          </div>
          <span v-if="item.Remark != ''">备注：{{ item.Remark }}</span>
        </div>
        <div
          class="flex"
          v-for="(ite, idx) in item.GetOrderDetails"
          :class="idx < item.GetOrderDetails.length - 1 ? 'borderBottom' : ''"
          :key="idx"
        >
          <div class="p20 borderRight">
            <el-image
              style="width: 200px; height: 120px"
              :src="goodUrl + ite.CommodityPicURL"
              alt=""
            />
          </div>
          <div class="p20 flex w30vw borderRight text-left">
            <div class="flex1">
              <div class="marginBottom">{{ ite.CommodityName }}</div>
              <div
                :class="ite.OrderType == '一口价' ? 'text-blue' : 'text-red'"
              >
                {{ ite.OrderType }}
              </div>
            </div>
            <span>{{ ite.CommodityNum }}</span>
          </div>
          <div class="p20 borderRight w30vw">
            <el-image
              style="width: 100px; height: 100px; border-radius: 10px"
              :src="CSetting + ite.ShopLOGO"
              alt=""
            />
            <div>{{ ite.ShopName }}</div>
          </div>
          <div class="p20 borderRight w8vw lineHeight">
            应付金额：{{ ite.OrderAmount }} <br />
            折扣金额：{{ ite.DiscountAmount }}<br />

            已付金额：<span class="bold">{{
              ite.OrderState == "待付款" ? 0 : ite.PayAmount
            }}</span
            ><br />

            未付金额：<span class="text-red">{{ ite.NoPayAmount }}</span>
          </div>
          <div class="p20 borderRight lineHeight w100">
            <div class="text-red">{{ ite.OrderState }}</div>
            <div
              class="text-blue pointer"
              v-if="ite.OrderState == '待发货'"
              @click="sendGoods(ite)"
            >
              去发货
            </div>
            <div
              class="text-blue pointer"
              v-if="ite.OrderState == '待发货'"
              @click="changeStatus(ite,3,'已退款')"
            >
              去退款
            </div>
            <!-- <div
              class="text-blue pointer"
              v-if="
                ite.OrderState == '待发货' ||
                ite.OrderState == '待付款' ||
                ite.OrderState == '待收货'
              "
              @click="deteteFn(ite)"
            >
              去退货
            </div> -->
            <div
              class="text-blue pointer"
              v-if="ite.OrderState == '待付款'"
              @click="changeFn(ite)"
            >
              去改价
            </div>
            
            <div
              class="text-blue pointer"
              v-if="ite.OrderState == '待收货'"
              @click="changeStatus(ite,0,'仅退款')"
            >
              仅退款
            </div>
            <div
              class="text-blue pointer"
              v-if="ite.OrderState == '待收货'"
              @click="changeStatus(ite,1,'已退货待退款')"
            >
              退货
            </div>
            <div
              class="text-blue pointer"
              v-if="ite.OrderState == '已退货待退款'"
              @click="changeStatus(ite,2,'已退货已退款')"
            >
              退款
            </div>
          </div>
          <div class="w30vw p20 lineHeight">
            <div>
              {{ item.UserName }}<br />{{ item.UserTel }}<br />{{
                item.UserAddress
              }}
            </div>
            <div @click="toDetail(item)" class="text-blue pointer">
              订单详情
            </div>
            <div @click="remarkFn(item)" class="text-blue pointer">备注</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页组件 -->
    <mPage
      :page="pageparm.currentPage"
      :total="pageparm.total"
      @change="changePage"
    ></mPage>
    <!-- 编辑界面 -->
    <el-dialog
      :title="'订单号：' + selectedInfo.OrderGUID"
      :visible.sync="editFormVisible"
      width="80%"
      @close="closeDialog('editForm')"
    >
      <el-button class="marginBottom">基础信息</el-button>
      <div class="marginBottom border lineHeight grayBgBox">
        <div class="flex borderBottom">
          <div class="grayBg">订单时间</div>
          {{ selectedInfo.CREATETIME }}
        </div>
        <div class="flex borderBottom">
          <div class="grayBg">客户名称</div>
          {{ selectedInfo.UserName }}
        </div>
        <div class="flex borderBottom">
          <div class="grayBg">联系方式</div>
          {{ selectedInfo.UserTel }}
        </div>
        <div class="flex borderBottom">
          <div class="grayBg">详细地址</div>
          {{ selectedInfo.UserAddress }}
        </div>
        <div class="flex borderBottom">
          <div class="grayBg">支付方式</div>
          {{ selectedInfo.PayWay }}
        </div>
        <div class="flex">
          <div class="grayBg">备注</div>
          {{ selectedInfo.Remark }}
        </div>
      </div>
      <el-button class="marginBottom">商品信息</el-button>

      <el-table
        size="small"
        :data="details"
        highlight-current-row
        v-loading="loading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          prop="CommodityName"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="UnitPrice"
          label="单价"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="OrderState"
          label="状态"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="CommodityNum"
          label="数量"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="FTicketValue"
          label="礼券"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="FullReductionAmount"
          label="满减"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="OrderAmount"
          label="金额"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="CREATETIME"
          label="下单时间"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import mPage from "../../components/mPage.vue";
let flag = true;
export default {
  components: { mPage },
  data() {
    return {
      CSetting: this.$Url + "BSetting/",
      goodUrl: this.$goodUrl,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      OrderStates: [
        { key: "所有", value: "0" },
        { key: "待付款", value: "1" },
        { key: "待发货", value: "2" },
        { key: "待收货", value: "3" },
        { key: "已完成", value: "4" },
        // { key: "已退货待退款", value: "5" },
        // { key: "已退货已退款", value: "6" },
      ],
      formInline: {
        page: 1,
        limit: 10,
        OrderID: "",
        CommodityName: "",
        Source: "",
        time: [],
        OrderStateID: "0",
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      canNext: true,
      GlobalOrderID: "G9999123199999",
      selectedInfo: {},
      details: [],
    };
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.personInfo = JSON.parse(this.$util.getStore("personInfo"));
    this.getdata();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    sendGoods(e) {
      this.$prompt("物流单号", "发货", {
        confirmButtonText: "确定发货",
        showCancelButton: false,
        // inputType: "textarea",
        inputPattern: /^.+$/,
        customClass: "mflex",
        inputErrorMessage: "请输入要快递单号",
      })
        .then(({ value }) => {
          e.OrderState = "待收货";
          this.UpdateOrderState(e, value);
        })
        .catch(() => {
          console.log(39888);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    deteteFn(e) {
      this.$confirm("是否确定退货?", "退货", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        type: "warning",
      })
        .then(() => {
          console.log(e, 3333);
          e.OrderState = "已退货";
          this.UpdateOrderState(e);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    changeStatus(e,i,str){
      this.$confirm("是否更改为"+str+'？', "", {
        confirmButtonText: "确定",
        cancelButtonText: "关闭",
        type: "warning",
      })
        .then(() => {
          console.log(e, 3333);
          e.OrderState =str;
          this.UpdateOrderState(e);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    UpdateOrderState(e, LogisticsNo = "") {
      this.$loading();
      this.$api
        .ExSqlFn("ShopWebApp\\UpdateOrderState_1_0_2&DBC=w_b1∑w_b2", {
          OrderState: e.OrderState,
          LogisticsNo: LogisticsNo,
          OrderDetailGUID: e.OrderDetailGUID,
        })
        .then((res) => {
          let result = res.data,
            list = {};
          this.$loading().close();
          if (result.OK != "True") {
            this.$message({
              message: result.Message,
              type: "success",
            });
          } else if (result.Tag[0] == 0) {
            this.$message({
              message: "修改失败",
              type: "success",
            });
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.GlobalOrderID = "G9999123199999";
          this.formInline.page = 1;
          this.getdata();
        });
    },
    changeFn(e) {
      this.$prompt("应收款", "改价", {
        confirmButtonText: "确定",
        showCancelButton: false,
        // inputType: "textarea",
        inputPattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.][0-9]*[1-9]$/,
        customClass: "mflex",
        inputErrorMessage: "请输入大于0的金额",
      })
        .then(({ value }) => {
          this.$loading();
          this.$api
            .ExSqlFn("ShopWebApp\\UpdateOrderAmount_1_0_2&DBC=w_b1∑w_b2", {
              OrderAmount: value,
              OrderDetailGUID: e.OrderDetailGUID,
            })
            .then((res) => {
              let result = res.data,
                list = {};
              this.$loading().close();
              if (result.OK != "True") {
                this.$message({
                  message: result.Message,
                  type: "success",
                });
              } else if (result.Tag[0] == 0) {
                this.$message({
                  message: "修改失败",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              }
              this.GlobalOrderID = "G9999123199999";
              this.formInline.page = 1;
              this.getdata();
            });
        })
        .catch(() => {
          console.log(39888);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    remarkFn(e) {
      this.$prompt("备注", "备注", {
        confirmButtonText: "确定",
        showCancelButton: false,
        inputType: "textarea",
        inputPattern: /^.+$/,
        customClass: "mflex",
        inputErrorMessage: "请输入",
      })
        .then(({ value }) => {
          this.$loading();
          this.$api
            .ExSqlFn("Web\\UpdateOrderRemark_1_0_2&DBC=w_b1∑w_b2", {
              Remark: value,
              OrderGUID: e.OrderGUID,
            })
            .then((res) => {
              let result = res.data;
              this.$loading().close();
              if (result.OK != "True") {
                this.$message({
                  message: result.Message,
                  type: "success",
                });
              } else if (result.Tag[0] == 0) {
                this.$message({
                  message: "修改失败",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              }
              this.GlobalOrderID = "G9999123199999";
              this.formInline.page = 1;
              this.getdata();
            });
        })
        .catch(() => {
          console.log(39888);
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    toDetail(e) {
      this.$router.push({
        path: "/orderDetail",
        query: { item: JSON.stringify(e) },
      });
    },
    changePage(e, i) {
      let { currentPage } = this.pageparm;
      if (e == 1) {
        currentPage--;
        this.GlobalOrderID = "G9999123199999";
        this.canNext = currentPage < 1 ? false : true;
      } else {
        if (this.canNext) {
          currentPage++;
        } else {
          this.pageparm.total = currentPage;
        }
      }
      console.log(currentPage, 1111);
      this.pageparm.currentPage = currentPage;
      this.formInline.page = currentPage;
      if (this.canNext) {
        this.getdata();
      }
    },
    // 获取公司列表
    getdata() {
      let {
        page,
        limit,
        OrderID,
        CommodityName,
        Source,
        orderStatus,
        time,
        OrderStateID,
      } = this.formInline;
      let data = {
          CompanyGUID: this.personInfo.CompanyGUID,
          OrderID,
          CommodityName,
          Source,
          orderStatus,
          OrderStateID,
          GlobalOrderID: page > 0 ? this.GlobalOrderID : "G9999123199999",
          StartDate: "",
          EndDate: "",
        },
        list = [];
      console.log(time, 380);
      if (time && time.length > 0) {
        data.StartDate = time[0];
        data.EndDate = time[1];
      }
      this.$loading();
      this.$api
        .QueryDataFn1(
          "Web\\GetOrderList_1_0_2,Web\\GetOrderDetails_1_0_2&DBC=r_b1∑r_b2",
          data
        )
        .then((res) => {
          let result = res.data;
          this.$loading().close();
          if (result.OK != "True") {
            this.$message({
              message: result.Message,
              type: "success",
            });
          } else if (result.Tag.length <= 0) {
          } else {
            list = result.Tag[0].Table;
            list.forEach((e) => {
              e.UserName = decodeURIComponent(e.UserName);
            });
            this.canNext = list.length > 0 ? true : false;
            this.pageparm.total =
              list.length > 0
                ? this.pageparm.currentPage + 1
                : this.pageparm.currentPage;
            this.GlobalOrderID = list[list.length - 1].GlobalOrderID;
          }
          this.listData = list;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.GlobalOrderID = "G9999123199999";
      this.formInline.page = 1;
      this.getdata(this.formInline);
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped >
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.eltable {
  border: 1px solid #ebeef5;
  max-height: 71vh;
  margin-bottom: 10px;
  overflow-y: scroll;
}
.title {
  border-bottom: 1px solid #ebeef5;
  line-height: 2;
  padding: 20px;
}
.grayBg {
  background: #eee;
  display: inline-block;
  width: 100px;
  padding: 0 20px;
  margin-right: 20px;
  border-right: 1px solid #ebeef5;
  text-align: center;
}
.grayBgBox {
  width: 500px;
  line-height: 3;
}
.w100 {
  width: 100px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Order.vue